import { getHistory, getStreak, getTaskStats, calcPercent, getDayData, formatDate, getTasks } from '../storage.js';

const DAY_LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];

function heatColor(pct) {
  if (pct === 0) return '#F0E8E4';
  return `rgba(201,144,124,${0.15 + (pct / 100) * 0.75})`;
}

function buildHeatmap(weekData) {
  return weekData.map((d, i) => {
    const isFuture = d.percent === null;
    const bright   = !isFuture && d.percent > 60;
    return `
      <div class="heat-cell">
        <div class="heat-block" style="background:${isFuture ? 'rgba(44,36,32,0.05)' : heatColor(d.percent)}">
          ${!isFuture ? `<span class="heat-pct ${bright ? 'bright' : ''}">${d.percent}%</span>` : ''}
        </div>
        <span class="heat-day">${DAY_LABELS[i]}</span>
      </div>`;
  }).join('');
}

function getWeekData(tasks) {
  const today     = new Date();
  const todayStr  = formatDate(today);
  const dayOfWeek = (today.getDay() + 6) % 7; // 0=Mon, 6=Sun
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() - dayOfWeek + i);
    const date     = formatDate(d);
    const isFuture = date > todayStr;
    if (isFuture) return { date, percent: null };
    const data    = getDayData(date);
    const percent = calcPercent(tasks, data);
    return { date, percent };
  });
}

function buildTaskListItems(items, type) {
  return items.map((c, i) => {
    const last = i === items.length - 1;
    if (type === 'done') {
      return `
        <div class="task-list-item ${last ? 'last' : ''}">
          <div class="task-list-icon done-icon">
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
              <path d="M1 4L3.5 6.5L9 1" stroke="var(--done)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="task-list-name">${c.task.label}</span>
        </div>`;
    }
    return `
      <div class="task-list-item ${last ? 'last' : ''}">
        <div class="task-list-icon skip-icon">
          <div style="width:6px;height:6px;border-radius:99px;background:var(--accent);opacity:0.6"></div>
        </div>
        <span class="task-list-name">${c.task.label}</span>
      </div>`;
  }).join('');
}

export function render(container) {
  const tasks     = getTasks();
  const weekData  = getWeekData(tasks);
  const history30 = getHistory(30);

  const streak  = getStreak();
  const bestPct = Math.max(...history30.map(d => d.percent), 0);
  const filledDays = weekData.filter(d => d.percent !== null && d.percent > 0);
  const avgPct  = filledDays.length
    ? Math.round(filledDays.reduce((s, d) => s + d.percent, 0) / filledDays.length)
    : 0;

  const taskStats = getTaskStats(30);
  const top3      = taskStats.slice(0, 3);
  const skip3     = [...taskStats].reverse().slice(0, 3);

  container.innerHTML = `
    <div class="view">
      <div class="view-header">
        <p class="view-eyebrow">Цього тижня</p>
        <h1 class="view-title">Твої патерни</h1>
      </div>

      <div class="card" style="padding:16px 18px;margin-bottom:16px">
        <p class="view-eyebrow" style="margin-bottom:14px">Тижневий огляд</p>
        <div class="heatmap-grid">${buildHeatmap(weekData)}</div>
      </div>

      <div class="stat-blocks">
        <div class="stat-block">
          <div class="stat-value-row">
            <span class="stat-value">${streak}</span>
            <span class="stat-unit">днів</span>
          </div>
          <span class="stat-label">Поточна серія</span>
        </div>
        <div class="stat-block">
          <div class="stat-value-row">
            <span class="stat-value">${bestPct}</span>
            <span class="stat-unit">%</span>
          </div>
          <span class="stat-label">Найкращий день</span>
        </div>
        <div class="stat-block">
          <div class="stat-value-row">
            <span class="stat-value">${avgPct}</span>
            <span class="stat-unit">%</span>
          </div>
          <span class="stat-label">Сер. за тиждень</span>
        </div>
      </div>

      <div class="card task-list-card">
        <p class="task-list-title">Ти завжди робиш</p>
        ${top3.length
          ? buildTaskListItems(top3, 'done')
          : '<p style="font-size:13px;color:var(--text-muted)">Ще немає даних</p>'}
      </div>

      <div class="card task-list-card" style="margin-bottom:0">
        <p class="task-list-title">Ти часто пропускаєш</p>
        ${skip3.length
          ? buildTaskListItems(skip3, 'skip')
          : '<p style="font-size:13px;color:var(--text-muted)">Ще немає даних</p>'}
      </div>
    </div>`;
}
